"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Information = void 0;
var React = require("react");
var Icon_styled_1 = require("../Icon.styled");
var common_styles_1 = require("@next-components/common-styles");
/**
 * Source: https://github.com/microsoft/fluentui-system-icons/blob/master/icons.md
 * name: "Person (Filled)"
 */
exports.Information = function (props) { return (React.createElement(Icon_styled_1.StyledSvg, { width: "22", height: "22", viewBox: "0 0 22 22", fill: "none" },
    React.createElement("circle", { cx: "11", cy: "11", r: "11", fill: common_styles_1.secondary }),
    React.createElement("path", { d: "M10 10C10 9.44772 10.4477 9 11 9C11.5523 9 12 9.44772 12 10V15C12 15.5523 11.5523 16 11 16C10.4477 16 10 15.5523 10 15V10Z", fill: props.fill || common_styles_1.white }),
    React.createElement("path", { d: "M10 7C10 6.44772 10.4477 6 11 6C11.5523 6 12 6.44772 12 7C12 7.55228 11.5523 8 11 8C10.4477 8 10 7.55228 10 7Z", fill: props.fill || common_styles_1.white }))); };
//# sourceMappingURL=information.js.map